import { render } from "./CenterPanel.vue?vue&type=template&id=ae527cf2&scoped=true"
import script from "./CenterPanel.vue?vue&type=script&lang=js"
export * from "./CenterPanel.vue?vue&type=script&lang=js"

import "./CenterPanel.vue?vue&type=style&index=0&id=ae527cf2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae527cf2"]])

export default __exports__